module.exports = __webpack_public_path__ + "static/img/winners.5cbb0195.png";